export default __webpack_public_path__ + "static/media/366.d83435f7.png";